import React, {FunctionComponent} from "react";
import {observer_utility} from "../../../utility/observer_class";
import ContentPopup from "../../../components/popup-with-bar/content-popup";
import {CircularProgress, Typography} from "@mui/material";
import {IPrenotazioneUtente} from "../../../interfaces/utente";
import {Time_format, time_format} from "../../../utility/time_format";
import ActionButtonContainer from "../../../components/popup-with-bar/action-button-container";
import Button from "../../../components/Button/Button";
import {IPrenotazioniImpostazioni} from "../../../interfaces/prenotazioni_impostazioni";
import Popup from "../../../components/popup/popup";


interface Listener {
    update(data: Data | undefined): void
}

export interface Data {
    promise: Promise<IPrenotazioneUtente>,
    open: boolean
}

export class popup_prenotazione_singleton {
    public static observer: observer_utility.Observer<Data | undefined, Listener> =
        new observer_utility.Observer<Data | undefined, Listener>(
            (listener, data) => listener.update(data)
        )
}


interface Props {
    prenotazioni?: IPrenotazioniImpostazioni
}

interface State {
    open: boolean,
    loading: boolean,
    is_success: boolean,
    dati_prenotazione?: IPrenotazioneUtente,
    error?: string
}

export default class PopupPrenotazione extends React.Component<Props, State> implements Listener {
    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
            loading: true,
            is_success: false
        }
    }

    componentDidMount() {
        popup_prenotazione_singleton.observer.attach(this)
    }

    componentWillUnmount() {
        popup_prenotazione_singleton.observer.detach(this);
    }

    handle_close = () => popup_prenotazione_singleton.observer.notify(undefined)

    update(data: Data | undefined) {
        if (data === undefined) {
            this.setState({
                open: false,
                loading: true,
                is_success: false
            })
        } else {
            this.setState({open: true, loading: true});

            data.promise.then((prenotazione) => {
                if (typeof prenotazione === "string") throw prenotazione;
                this.setState({loading: false, is_success: true, dati_prenotazione: prenotazione})
            })
                .catch((err) => this.setState({is_success: false, error: err, loading: false}))
        }
    }

    render() {
        const {open} = this.state;

        return (
            <Popup title={"Stato prenotazione"} open={open} handle_close={this.handle_close}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    {
                        this.state.loading ? <CircularProgress/>
                            : (
                                this.state.is_success && this.state.dati_prenotazione !== undefined
                                    ? <SuccessContent data_prenotazione={this.state.dati_prenotazione}
                                                      prenotazioni={this.props.prenotazioni}/>
                                    : <ErrorContent error={this.state.error}/>
                            )
                    }
                </div>
                <ActionButtonContainer>
                    <Button onClick={this.handle_close}>
                        Chiudi
                    </Button>
                </ActionButtonContainer>
            </Popup>
        )
    }
}

const SuccessContent: FunctionComponent<{
    data_prenotazione: IPrenotazioneUtente,
    prenotazioni?: IPrenotazioniImpostazioni
}> = (props) => {

    const pre = props.data_prenotazione;

    const imp = props.prenotazioni;

    let free_date: Date | undefined = undefined;

    if (imp !== undefined && imp.isEnabled && imp.tipoDiPrenotazione === 2) {
        free_date = new Date(props.data_prenotazione.data);
        free_date.setHours(free_date.getHours() + imp.impostazioni.permanenza.ore, free_date.getMinutes() + imp.impostazioni.permanenza.minuti)
    }

    return (
        <div>
            <Typography>
                Complimenti, {pre.nome} la tua prenotazione per {pre.posti} persone,
                il {time_format.format_date(new Date(pre.data), true)} è arrivata correttamente al ristorante, attendi
                che venga accettata, riceverai una mail riguardo lo stato della prenotazione.
            </Typography>
            {
                free_date && (
                    <Typography>
                        Si avvisa che è necessario liberare il tavolo entro
                        le: {time_format.format(free_date, Time_format.ONLY_MINUTES)}
                    </Typography>
                )
            }
        </div>
    )
}

const ErrorContent: FunctionComponent<{
    error?: string
}> = (props) => {

    const error = props.error

    return (
        <div>
            <Typography>
                Spiacente, ma non è possibile completare la sua richiesta di prenotazione.
            </Typography>
            <Typography color={"error"}>{error}</Typography>
        </div>
    )
}